import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Loader2, Save, Layers } from "lucide-react";
import { toast } from "sonner";

const GROUPS = [
  ["Global", [["schema_auto_generate", "Auto-generate schema (off = only custom JSON-LD is published)"]]],
  ["Homepage", [["schema_organization", "Organization"], ["schema_website", "WebSite"], ["schema_webpage", "WebPage"], ["schema_localbusiness", "LocalBusiness (needs address + phone)"]]],
  ["Product pages", [["schema_product", "Product (name, brand, SKU, image, description)"], ["schema_offer", "Offer (NZD price, stock availability)"]]],
  ["Category & brand pages", [["schema_collectionpage", "CollectionPage"]]],
  ["All pages", [["schema_breadcrumb", "BreadcrumbList"]]],
];

export function SchemaTemplates() {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/seo/automation").then((r) => setF(r.data)).catch(() => setF(false)); }, []);
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/admin/seo/automation", f); setF(r.data); toast.success("Schema templates saved"); }
    catch { toast.error("Could not save"); } finally { setSaving(false); }
  };
  if (!f) return null;
  return (
    <section data-testid="schema-templates">
      <h3 className="font-bold text-steel flex items-center gap-2 mb-1"><Layers size={18} /> Global settings &amp; page-type templates</h3>
      <p className="text-xs text-muted-foreground mb-3">Choose which schema types each page type publishes. Only real catalogue data is used — no reviews, ratings or GTINs are generated.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {GROUPS.map(([g, items]) => (
          <div key={g} className="rounded-xl border bg-white p-3 space-y-2">
            <div className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{g}</div>
            {items.map(([k, label]) => (
              <label key={k} className="flex items-center justify-between gap-3 text-sm text-steel">
                {label}
                <Switch checked={!!f[k]} onCheckedChange={(v) => setF({ ...f, [k]: v })} data-testid={`schema-flag-${k}`} />
              </label>
            ))}
          </div>
        ))}
      </div>
      <Button size="sm" className="mt-3 bg-accent text-steel hover:bg-amber-600 font-semibold" onClick={save} disabled={saving} data-testid="schema-templates-save">
        {saving ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Save size={14} className="mr-1.5" />} Save templates
      </Button>
    </section>
  );
}
